import http from '@/plugins/axios/axios';

export default class AutorizacaoSuporteService {

    atualizarRefAcessoSuporte(requisicao) {       
        return http.post('/api/autorizacao-suporte/atualizar-ref-acesso', requisicao);
    } 
    
    fecharSuporte(requisicao) {       
        return http.post('/api/autorizacao-suporte/fechar', requisicao);
    } 

    listar(idEmpresa, ano, mes) {       
        return http.get('/api/autorizacao-suporte/listar-suporte?idEmp='+idEmpresa+'&a='+ano+'&m='+mes);
    }   
}